import { FC, PropsWithChildren } from "react";
import { ThemeProvider } from "@mui/material";
import { GlobalModalContextProvider } from "src/utils/GlobalModal/GlobalModalContext";
import { PermissionsContextProvider } from "src/utils/Permissions/PermissionsContext";
import { theme } from "src/theme/theme";
import { getLanguage } from "src/utils/Languages/LanguageContext";

const OrganizationStructureProviders: FC<PropsWithChildren> = ({
  children,
}) => {
  const language = getLanguage();

  return (
    <PermissionsContextProvider>
      <ThemeProvider theme={theme({ language })}>
        <GlobalModalContextProvider>{children}</GlobalModalContextProvider>
      </ThemeProvider>
    </PermissionsContextProvider>
  );
};

export default OrganizationStructureProviders;
